import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveUserPreferences, SaveForm30UserPreferencesRequest } from '../../services/network/form30UserPreferences-api';

export const useSaveForm30UserPreferences = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (data: SaveForm30UserPreferencesRequest) => saveUserPreferences(data),
        onSuccess: () => {
            // Инвалидируем кэш предпочтений пользователя
            queryClient.invalidateQueries({ queryKey: ['form30UserPreferences'] });
        },
    });

    return {
        savePreferences: mutation.mutate,
        isLoading: mutation.isPending,
        isError: mutation.isError,
        error: mutation.error,
    };
};
